import { useEffect } from 'react';
import Header from '@/pages/home/components/Header';
import Hero from '@/pages/home/components/Hero';
import Tonight from '@/pages/home/components/Tonight';
import Calendar from '@/pages/home/components/Calendar';
import Genres from '@/pages/home/components/Genres';
import Ranking from '@/pages/home/components/Ranking';
import News from '@/pages/home/components/News';
import Guide from '@/pages/home/components/Guide';
import Faq from '@/pages/home/components/Faq';
import Testimonials from '@/pages/home/components/Testimonials';
import Subscribe from '@/pages/home/components/Subscribe';
import Footer from '@/pages/home/components/Footer';

const title = '55吃瓜｜连续剧追更站，今晚最新剧情在线抢先看';
const description =
  '55吃瓜连续剧追更站，今晚最新剧情在线抢先看。从开播到高潮全程无缝衔接，每集都有新瓜落地，追更日历与更新提醒快人一步，让你永远走在吃瓜最前线，追更不迷路。';

export default function Home() {
  useEffect(() => {
    document.title = title;
    const setMeta = (name: string, content: string) => {
      let el = document.querySelector(`meta[name="${name}"]`);
      if (!el) {
        el = document.createElement('meta');
        el.setAttribute('name', name);
        document.head.appendChild(el);
      }
      el.setAttribute('content', content);
    };
    setMeta('description', description);
    setMeta('keywords', '55吃瓜,55吃瓜更新,55吃瓜最新,55吃瓜连续剧,55吃瓜追更,55吃瓜在线,连续剧追更,今晚更新');
    setMeta('robots', 'index,follow');
    setMeta('og:title', title);
    setMeta('og:description', description);
    setMeta('og:type', 'website');
    setMeta('twitter:card', 'summary_large_image');
  }, []);

  return (
    <div className="min-h-screen bg-[#faf6ef]">
      {/* WebSite + Organization 结构化数据 */}
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@graph': [
              { '@type': 'WebSite', name: '55吃瓜·追更站', url: 'https://czhaoda.cn/', inLanguage: 'zh-CN' },
              {
                '@type': 'Organization',
                name: '55吃瓜·追更站',
                description: '连续剧追更资讯门户，提供今晚最新剧情、追更日历、热播榜单与剧情速递。',
              },
              {
                '@type': 'CollectionPage',
                name: title,
                description,
                inLanguage: 'zh-CN',
              },
            ],
          }),
        }}
      />

      <Header />
      <main>
        <Hero />
        <Tonight />
        <Calendar />
        <Genres />
        <Ranking />
        <News />
        <Guide />
        <Faq />
        <Testimonials />
        <Subscribe />
      </main>
      <Footer />
    </div>
  );
}